var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CTagsInput',{attrs:{"tags":_vm.value,"placeholder":_vm.placeholder,"has-error":_vm.isValid === false},on:{"change":_vm.handleTagsChange}}),_vm._v(" "),_c('FieldError',{attrs:{"error":_vm.error}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }